import React from 'react';
import './Hero.css';
import tortaImage from '../assets/Tipos de Rolls/torta.webp';

const Hero = ({ activeDotIndex = 0, onDotClick }) => {
  const dots = [{ id: 12, label: 'Menú' }];
  return (
    <section className="hero">
      <div className="hero-image">
        <img 
          src="https://images.pexels.com/photos/8518854/pexels-photo-8518854.jpeg?_gl=1*1dlz93v*_ga*MjAyMTI0OTYwOS4xNzY4OTI3NjE5*_ga_8JE65Q40S6*czE3NzA5MTQ4ODYkbzQkZzEkdDE3NzA5MTQ5NDYkajYwJGwwJGgw" 
          alt="Chef Margaro Hero"
          className="hero-image-img"
        />
        <div className="hero-black-overlay"></div>
        <div className="hero-overlay">
          <div className="hero-content">
            <div className="hero-left-column">
              <h1 className="hero-title">
                <span className="hero-chef">CHEF</span>
                <span className="hero-margaro">MARGARO</span>
                <span className="hero-tagline">¡Un placer cocinarles!</span>
              </h1>
            </div>
            <div className="hero-right-column">
              <img 
                src={tortaImage} 
                alt="Torta" 
                className="hero-torta-image"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="hero-dots" role="tablist" aria-label="Categorías del menú">
        {dots.map((dot, index) => (
          <button
            key={dot.id}
            type="button"
            role="tab"
            aria-selected={index === activeDotIndex}
            aria-label={dot.label}
            className={`dot ${index === activeDotIndex ? 'active' : ''}`}
            onClick={() => typeof onDotClick === 'function' && onDotClick(index)}
          />
        ))}
      </div> */}
    </section>
  );
};

export default Hero;

